export default {
  QUESTION_BUTTON: 'question_button',
  UNDERSTAND_BUTTON: 'understand_button',
  UNCLEAR_BUTTON: 'unclear_button',
  CALL_MANAGER: 'call_manager',
  TABLE_MODE: 'table_mode',
  SHOW_ORDER_FORM: 'show_order_form',
  USE_MINIMAP: 'minimap',
};
